import BaseSelection from "../../../../../components/elements/BaseSelection"
import { PositionData } from "../../../../../data/Types"
import { ReactComponent as MINUS } from "../../../../../assets/MinusCircle.svg"
import BaseInputField from "../../../../../components/elements/BaseInputField"
import { Form, FormInstance } from "antd"
import BaseCheckbox from "../../../../../components/elements/BaseCheckbox"
import { returnThousanderBreakInNumber } from "../../../../../services/functions"
import { PositionUnits } from "../../../../../api/constants"

type InputPositionDataType = {
    form: FormInstance
    index: number
    position: PositionData
    offer?: boolean
    setposition: (index: number, attribute: string, e: string | number | boolean) => void
    removePosition: (e: number) => void
}

export default function PositionInputs(props: InputPositionDataType) {
    return (
        <div className="flex flex-col w-full gap-1 px-4 pb-4 pt-2 rounded-default border relative mt-3">
            <div className="flex flex-row justify-between px-4 border-b py-2 mb-2">
                <div className="flex gap-8 items-center ">
                    <p className="pl-0">Position {props.index + 1}</p>
                    {props.offer && (
                        <BaseCheckbox classProps="!gap-2 !mt-0" setcheck={() => props.setposition(props.index, "optional", !props.position.optional)} label={"Optional"} />
                    )}
                </div>
                {props.index >= 1 && <MINUS className="w-6 h-6 cursor-pointer" onClick={() => props.removePosition(props.index)} />}
            </div>
            <div className="flex flex-row w-full gap-4">
                <Form.Item className="w-48 mb-2" name={"amount-" + props.index} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField label={"Menge"} type={"number"} onChange={(e) => props.setposition(props.index, "amount", e)} />
                </Form.Item>
                <Form.Item className="w-full mb-2" name={"unit-" + props.index} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseSelection
                        setId={(e) => {
                            props.form?.setFieldsValue({ [`unit-${props.index}`]: e })
                            props.setposition(props.index, "unit", e)
                        }}
                        data={PositionUnits}
                        label={"Einheit *"}
                        placeholder={"Bitte auswählen"}
                    />
                </Form.Item>
                <Form.Item className="w-64 mb-2" name={"tax-" + props.index} rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseSelection
                        setId={(e) => {
                            const fieldName = `tax-${props.index}`
                            if (e === "19%") {
                                props.form?.setFieldsValue({ [fieldName]: "19%" })
                                props.setposition(props.index, "tax", 19)
                            } else {
                                props.form?.setFieldsValue({ [fieldName]: "7%" })
                                props.setposition(props.index, "tax", 7)
                            }
                        }}
                        data={["19%", "7%"]}
                        label={"Abrechnung *"}
                        placeholder={"Bitte auswählen"}
                    />
                </Form.Item>
            </div>
            <div className="flex flex-row w-full gap-4 justify-end">
                <Form.Item
                    className="w-full mb-2"
                    name={"description-" + props.index}
                    rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        label={"Beschreibung"}
                        type={"text"}
                        onChange={(e) => {
                            props.setposition(props.index, "description", e)
                        }}
                    />
                </Form.Item>
                <Form.Item
                    className="w-48 mb-2"
                    name={"singlePrice-" + props.index}
                    rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                    <BaseInputField
                        prevent
                        label={"Einzelpreis (€)"}
                        type={"number"}
                        onChange={(e) => {
                            props.setposition(props.index, "singlePrice", e)
                        }}
                    />
                </Form.Item>
                <div className="flex flex-col justify-between w-48 items-end">
                    <label className="text-sm pl-2 pb-1">Gesamt</label>
                    <p className="font-semibold text-lg">{returnThousanderBreakInNumber(props.position?.singlePrice * props.position?.amount)} €</p>
                </div>
            </div>
        </div>
    )
}
